__turbopack_context__.v({
  "categoriesContainer": "CategoriesSection-module__t1pqdq__categoriesContainer",
  "categoryCard": "CategoriesSection-module__t1pqdq__categoryCard",
  "categoryGrid": "CategoriesSection-module__t1pqdq__categoryGrid",
  "categoryIcon": "CategoriesSection-module__t1pqdq__categoryIcon",
  "categoryMeta": "CategoriesSection-module__t1pqdq__categoryMeta",
  "categoryName": "CategoriesSection-module__t1pqdq__categoryName",
  "categorySlug": "CategoriesSection-module__t1pqdq__categorySlug",
  "categoryTitle": "CategoriesSection-module__t1pqdq__categoryTitle",
  "errorMessage": "CategoriesSection-module__t1pqdq__errorMessage",
  "fadeIn": "CategoriesSection-module__t1pqdq__fadeIn",
  "float": "CategoriesSection-module__t1pqdq__float",
  "loadingSpinner": "CategoriesSection-module__t1pqdq__loadingSpinner",
  "seeMoreButton": "CategoriesSection-module__t1pqdq__seeMoreButton",
  "seeMoreContainer": "CategoriesSection-module__t1pqdq__seeMoreContainer",
  "slideUp": "CategoriesSection-module__t1pqdq__slideUp",
  "spin": "CategoriesSection-module__t1pqdq__spin",
});
